import { e } from "mathjs";
import { UnitValue } from "../../data-structures/unit-value.model";

export interface EnergyGenerationUnitInterface {
  uuid: string;
  name: string;
  unitType: EnergyUnitTypes;
  electricalEfficiency: UnitValue;
  thermalEfficiency: UnitValue;
  nominalCapacityToggle: boolean;
  nominalCapacity: UnitValue;
  minimumOutput: UnitValue;
  workingPeriod: UnitValue;
  heatingValue: UnitValue;
}

export class EnergyGenerationUnit {
  public uuid: string;
  public name: string;
  public unitType: EnergyUnitTypes;
  public electricalEfficiency: UnitValue;
  public thermalEfficiency: UnitValue;
  public nominalCapacityToggle: boolean;
  public nominalCapacity: UnitValue;
  public minimumOutput: UnitValue;
  public workingPeriod: UnitValue;
  public heatingValue: UnitValue;


  constructor(param: EnergyGenerationUnitInterface = {
    uuid: undefined,
    name: '',
    unitType: null,
    nominalCapacityToggle: false,
    workingPeriod: new UnitValue(),
    nominalCapacity: new UnitValue(),
    minimumOutput: new UnitValue(),
    electricalEfficiency: new UnitValue(),
    heatingValue: new UnitValue(),
    thermalEfficiency: new UnitValue(),
  }) {
    this.uuid = param.uuid;
    this.name = param.name;
    this.unitType = param.unitType;
    this.nominalCapacityToggle = param.nominalCapacityToggle;
    this.nominalCapacity = new UnitValue(param.nominalCapacity);
    this.minimumOutput = new UnitValue(param.minimumOutput);
    this.workingPeriod = new UnitValue(param.workingPeriod);
    this.heatingValue = new UnitValue(param.heatingValue);
    this.electricalEfficiency = new UnitValue(param.electricalEfficiency);
    this.thermalEfficiency = new UnitValue(param.thermalEfficiency);
  }

  static deepCopy(egu: EnergyGenerationUnit) {
    let copy;
    if (egu) {
      copy = new EnergyGenerationUnit(egu);
      return copy;
    }
    throw new Error('energy generation unit deep copy failed');
  }

  // getValid(): ProjectValidationUnit {
  //   const validationUnit = new ProjectValidationUnit();
  //   if (this.name) {
  //     validationUnit.setValid(EnergyGenPropName.Name);
  //   } else {
  //     validationUnit.setInvalid(EnergyGenPropName.Name, [EnergyGenErrorMessage.MissingName]);
  //   }
  //   if (Object.values(EnergyUnitTypes).includes(this.unitType)) {
  //     validationUnit.setValid(EnergyGenPropName.unitType);
  //   } else {
  //     validationUnit.setInvalid(EnergyGenPropName.unitType, [EnergyGenErrorMessage.MissingType]);
  //   }
  //   validationUnit.addModuleResults(new UnitValueValidation(this.workingPeriod).getValidation(), EnergyGenPropName.WorkingPeriod);
  //   validationUnit.addModuleResults(new UnitValueValidation(this.nominalOutput).getValidation(), EnergyGenPropName.NominalOutput);
  //   if (this.unitType === EnergyUnitTypes.Chp || this.unitType === EnergyUnitTypes.Generator) {
  //     validationUnit.addModuleResults(new UnitValueValidation(this.minimumOutput).getValidation(), EnergyGenPropName.MinimumOutput);
  //     validationUnit.addModuleResults(new UnitValueValidation(this.electricalEfficiency).getValidation(), EnergyGenPropName.ElectricalEfficiency);
  //   }
  //   validationUnit.addModuleResults(new UnitValueValidation(this.lowerHeatingValue).getValidation(), EnergyGenPropName.LowerHeatingValue);
  //   if (this.unitType === EnergyUnitTypes.Chp || this.unitType === EnergyUnitTypes.Boiler) {
  //     validationUnit.addModuleResults(new UnitValueValidation(this.thermalEfficiency).getValidation(), EnergyGenPropName.ThermalEfficiency);
  //   }
  //   if (this.unitType === EnergyUnitTypes.Chp) {
  //     validationUnit.addModuleResults(new UnitValueValidation(this.heatUtilization).getValidation(), EnergyGenPropName.HeatUtilization);
  //   }
  //   // Only validate minimum and nominal outputs if filled out completely
  //   if (this.nominalOutput.unit && this.nominalOutput.value && this.minimumOutput.unit && this.minimumOutput.value) {
  //     const nominalOutputValue = this.nominalOutput.value;
  //     const minimumOutputValue = Unit.convertValue(this.minimumOutput.value, this.minimumOutput.unit, this.nominalOutput.unit);
  //     if (nominalOutputValue <= minimumOutputValue) {
  //       validationUnit.setInvalid(EnergyGenPropName.NominalOutput, [
  //         EnergyGenErrorMessage.NominalLowerThanMinimum
  //       ]);
  //     }
  //   }
  //   return validationUnit;
  // }

  // getInputSummary() {
  //   const inputSummary = new InputSummary();
  //   inputSummary.pushInput(EnergyGenPropName.UnitType, this.unitType);
  //   inputSummary.pushInput(EnergyGenPropName.WorkingPeriod, this.workingPeriod);
  //   inputSummary.pushInput(EnergyGenPropName.NominalOutput, this.nominalOutput);
  //   if (this.unitType === EnergyUnitTypes.Chp || this.unitType === EnergyUnitTypes.Generator) {
  //     inputSummary.pushInput(EnergyGenPropName.MinimumOutput, this.minimumOutput);
  //     inputSummary.pushInput(EnergyGenPropName.ElectricalEfficiency, this.electricalEfficiency);
  //   }
  //   inputSummary.pushInput(EnergyGenPropName.LowerHeatingValue, this.lowerHeatingValue);
  //   if (this.unitType === EnergyUnitTypes.Chp || this.unitType === EnergyUnitTypes.Boiler) {
  //     inputSummary.pushInput(EnergyGenPropName.ThermalEfficiency, this.thermalEfficiency);
  //   }
  //   return inputSummary;
  // }
}

export enum EnergyUnitTypes {
  Chp = 'PROJECT.PLANT_SPEC.CHP',
  Generator = 'PROJECT.PLANT_SPEC.GENERATOR',
  Boiler = 'PROJECT.PLANT_SPEC.BOILER'
}

export enum EnergyGenPropName {
  name = 'COMMON.NAME',
  unitType = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.TYPE',
  workingPeriod = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.WORKING_PERIOD',
  nominalCapacity = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.NOMINAL_CAPACITY',
  minimumOutput = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.MINIMUM_OUTPUT',
  electricalEfficiency = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.ELECTRICAL_EFFICIENCY',
  heatingValue = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.HEATING_VALUE',
  thermalEfficiency = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.THERMAL_EFFICIENCY',

  id_workingPeriod = 'annual working period',
  id_nominalCapacity = 'nominal capacity',
  id_minimumOutput = 'minimum output',
  id_electricalEfficiency = 'electrical efficiency',
  id_heatingValue = 'heating value',
  id_thermalEfficiency = 'thermal efficiency',

}

export enum EnergyGenErrorMessage {
  MissingName = 'VALIDATION.MISSING_NAME',
  NominalLowerThanMinimum = 'VALIDATION.NOMINAL_LOWER_THAN_MINIMUM',
  MissingType = 'VALIDATION.MISSING_TYPE'
}